export default __webpack_public_path__ + "static/features-31109683642747bd01c50cedb9dacb39.svg";